jQuery(function() {
    $('.textblock__spoiler-text').hide();
    $('.textblock__spoiler').click(function() {
        $(this)
            .next()
            .slideToggle('slow');
    });
});



// WEBPACK FOOTER //
// ./blocks/textblock.js